import { useCallback } from "react";

import { PropertyValue } from "src/types/property";

import { useFormatTypedValue } from "../useFormatTypedValue";

export const useFormatPropertyValue = () => {
  const formatTypedValue = useFormatTypedValue();

  const formatPropertyValue = useCallback(
    (property: PropertyValue) => {
      return formatTypedValue(property.value);
    },
    [formatTypedValue]
  );

  return formatPropertyValue;
};
